import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { useGetAllEnumListQuery } from '@/api/common';
import { useSelector } from 'react-redux';
import { selectMyInfo } from '@/pages/auth/authSlice';

export default function CaseSharedSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<any>();
	const userInfo = useSelector(selectMyInfo);

	const { data: allEnumList } = useGetAllEnumListQuery(null, {
		refetchOnMountOrArgChange: true,
	});
	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid size={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='currentRiskLevelList'
					label={t('case.currentRiskLevel')}
					options={(allEnumList?.data.RiskLevelEnum || []).map((item: any) => {
						return {
							...item,
							id: item.code,
							name: item.desc,
						};
					})}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='statusList'
					label={t('member.status')}
					options={(allEnumList?.data.MemberStatusEnum || []).map(
						(item: any) => {
							return {
								...item,
								id: item.code,
								name: item.desc,
							};
						}
					)}
				/>
			</Grid>
		</Grid>
	);
}
